export const identity = (v) => (v)
